// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user_user__1_RQp {\n  display: flex;\n}\n.user_user__1_RQp > div:first-child {\n  margin-right: 6px;\n  width: 40px;\n  height: 40px;\n}\n\n.user_info__2hgaA {\n  text-align: center;\n}\n\n.user_name__EBHA8 {\n  color: var(--gold);\n  font-weight: bold;\n}\n\n.user_rating__1-n4x {\n  font-size: 0.8rem;\n  white-space: nowrap;\n}\n.user_rating__1-n4x span:last-of-type {\n  color: var(--gold);\n  font-weight: bold;\n}\n.user_rating__1-n4x svg {\n  margin: 0 2px;\n}", ""]);
// Exports
exports.locals = {
	"user": "user_user__1_RQp",
	"info": "user_info__2hgaA",
	"name": "user_name__EBHA8",
	"rating": "user_rating__1-n4x"
};
module.exports = exports;
